import React, { useContext, useEffect, useRef, useState } from 'react'
import Logo from '../assets/images/svbk_logo.png'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { verifyLogin } from '../redux/features/login/loginSlice';
import { Spinner } from 'react-bootstrap';
import { useNavigate, Navigate } from 'react-router-dom';
import AppContext from '../storage/AppContext';
import useToast from '../shared/Toast'
import "./login.css"

function LoginContainer() {
  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [errorMsg,setErrorMsg] = useState(false);
  const [loginStatus,setLoginStatus] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const appContext = useContext(AppContext);
  const showToast = useToast();

  const passwordInputFieldRef = useRef("passwordInputFieldRef")
  const loginButtonRef = useRef("loginButtonRef")


  const userProfile = useSelector(state => state.login.loginDetails)
  console.log("userProfile",userProfile)

  useEffect(() => {
    if(userProfile.active){
        appContext.setUserDetails({...userProfile.userDetails, active: userProfile.active})
        if(userProfile?.userDetails?.data?.role !== "Admin"){
            navigate('/viewStudentDetails')
        }else{
            navigate('/uploadStudentDetails')
        }
    }
    if(userProfile.status === "failed"){
      showToast({ message: userProfile.error, type : "error" })
      const loginIntervalId = setInterval(() => {
        setLoginStatus(true)
        clearInterval(loginIntervalId)
      }, 3000)
    }
  },[userProfile])

  const onClickLogin = () => {
      if(!email || !password){
        setErrorMsg(true)
      }else{
        setErrorMsg(false)
        if(loginStatus) {
          setLoginStatus(false)
          const emailTrimmed = email.trim()
          dispatch(verifyLogin({email: emailTrimmed,password}))
        }
      }
  }

  const focusRefOnEnter = (event, ref) => {
    if(event.key === "Enter" && ref){
      ref.current.focus()
    }
  }

  const userDetails = appContext?.userDetails
  
  if(userDetails?.active === true){
    if(userDetails?.data?.role !== "Admin"){
      return <Navigate to="/viewStudentDetails" />
    }
      return <Navigate to="/uploadStudentDetails" />
  }


  return (
    <>
    {userProfile.status === "loading" ? 
     <div style={{ minHeight: '80vh' }} className='d-flex justify-content-center align-items-center'>
     <Spinner animation="border" role="status"></Spinner>
   </div>
    :
    <div className='d-flex justify-content-center align-items-center' style={{height:"100vh"}}>
    <div className='d-flex flex-column p-4 login-card' style={{boxShadow:"0 8px 40px rgb(7 7 7 / 8%)", borderRadius:"5px"}}>
        <img src="https://aautifileuploads.blob.core.windows.net/svbk/svbk_logo.png" style={{height:"200px", width:"200px", alignSelf:"center"}}/>
        <Form>
          <h4 className="text-center title-md">Login to your account</h4>
          {errorMsg && <p className="text-center" style={{color:"red"}}>Please Enter Email and Password</p>}
          <div className="form-group cont mt-4 w-100">
            <Form.Control
              type="text" 
              className="form-control"
              value={email}
              name="email" 
              placeholder="Enter your email"
              onChange={(e) => {setEmail(e.target.value)}}
              onKeyDown={event => focusRefOnEnter(event, passwordInputFieldRef)}
              />
          </div> 
          <div className="form-group cont w-100">
            <Form.Control 
              type="password" 
              className="form-control"
              value={password}
              name="password" 
              placeholder="Enter your password"
              onChange={(e) => {setPassword(e.target.value)}}
              ref = {passwordInputFieldRef}
              onKeyDown={event => focusRefOnEnter(event, loginButtonRef)}
            />
          </div>
        </Form>
      <button ref={loginButtonRef} className='btn btn-primary' onClick={onClickLogin} >Login</button>
    </div>
    </div>}
    </>
  )
}

export default LoginContainer;